import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'ErrorNotifications'

export const ErrorNotificationsEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("PushErrorNotification")
]